import React from "react";
import { TrendingDown, Activity, Heart, ShieldCheck, Sparkles } from "lucide-react";
import { RELIEF_IMG, whatsappLink } from "../../lib/site";

const benefits = [
  { icon: TrendingDown, title: "Redução da frequência das crises", desc: "Espaçamento natural entre episódios — devolvendo previsibilidade ao seu dia." },
  { icon: Activity, title: "Diminuição da intensidade da dor", desc: "Quando a crise acontece, ela tende a ser mais branda e mais curta." },
  { icon: Sparkles, title: "Relaxamento muscular", desc: "Atua sobre a musculatura envolvida, aliviando tensão e gatilhos." },
  { icon: Heart, title: "Melhora da qualidade de vida", desc: "Mais energia, sono restaurador e disposição para o que importa." },
  { icon: ShieldCheck, title: "Tratamento seguro", desc: "Procedimento minimamente invasivo, conduzido por profissional habilitada." },
];

export const Treatment = () => {
  return (
    <section id="tratamento" data-testid="treatment-section" className="py-20 sm:py-24 lg:py-32 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5">
          <div className="relative">
            <div className="absolute -inset-4 bg-[#D4AF37]/10 rounded-lg" aria-hidden />
            <img
              src={RELIEF_IMG}
              alt="Paciente sentindo alívio da dor"
              className="relative rounded-lg shadow-xl object-cover w-full h-[480px]"
            />
          </div>
        </div>

        <div className="lg:col-span-7">
          <p className="overline text-[#D4AF37] mb-5">Como pode ajudar</p>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#0A2540] leading-tight tracking-tight">
            Como a Toxina Botulínica pode aliviar a sua dor
          </h2>
          <p className="mt-5 text-[#1A1A1A]/70 leading-relaxed">
            Quando aplicada de forma criteriosa e em pontos específicos, a
            Toxina Botulínica atua nos mecanismos que disparam a dor —
            promovendo alívio sustentado e melhora funcional.
          </p>

          <ul className="mt-10 space-y-6">
            {benefits.map((b, i) => {
              const Icon = b.icon;
              return (
                <li
                  key={b.title}
                  data-testid={`benefit-item-${i}`}
                  className="flex items-start gap-5"
                >
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-white border border-[#E9ECEF] grid place-items-center shadow-sm">
                    <Icon className="w-5 h-5 text-[#0D3B66]" strokeWidth={1.6} />
                  </div>
                  <div>
                    <h3 className="font-serif-display text-xl text-[#0A2540]">{b.title}</h3>
                    <p className="text-sm text-[#1A1A1A]/70 mt-1 leading-relaxed">{b.desc}</p>
                  </div>
                </li>
              );
            })}
          </ul>

          <a
            data-testid="treatment-cta"
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-10 inline-flex items-center justify-center bg-[#0D3B66] hover:bg-[#0A2540] text-white font-semibold px-7 py-4 rounded-sm transition-colors"
          >
            Quero conversar sobre o meu caso
          </a>
        </div>
      </div>
    </section>
  );
};
